<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Банковские транзакции
      <span v-if="total">({{ total }})</span>
    </h1>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Начальная дата</label>
          <el-date-picker
            v-model="filters.datetime__gte"
            input-id="datetime-gte"
            input-class="form-control"
            type="date"
            placeholder="Начальная дата">
          </el-date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Конечная дата</label>
          <el-date-picker
            v-model="filters.datetime__lte"
            input-id="datetime-lte"
            input-class="form-control"
            type="date"
            placeholder="Конечная дата">
          </el-date-picker>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Сумма, от</label>
          <input type="text" placeholder="грн" class="form-control" v-model="filters.amount__gte">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Сумма, до</label>
          <input type="text" placeholder="грн" class="form-control" v-model="filters.amount__lte">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>Тип операции</label>
          <el-select
            placeholder="Выберите тип операции"
            v-model="filters.transaction_type"
            >
            <el-option value="" label="- Все -"></el-option>
            <el-option value="D" label="+ Дебет"></el-option>
            <el-option value="C" label="- Кредит"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label>Поиск по номеру по назначению</label>
          <input type="text" placeholder="Введите номер или назначение транзакции" class="form-control" v-model="filters.search">
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Распознана</label>
          <el-select
            placeholder="Выберите вариант"
            v-model="filters.recognized"
            >
            <el-option value="" label="- Все -"></el-option>
            <el-option value="1" label="Да"></el-option>
            <el-option value="0" label="Нет"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Исключить "@2PL"</label>
          <el-select
            placeholder="Выберите вариант"
            v-model="filters.exclude_2pl"
            >
            <el-option value="0" label="Нет"></el-option>
            <el-option value="1" label="Да"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="text-right">
      <a class="red" href="#" @click.prevent="showSync = !showSync">
        <span v-if="!showSync">синхронизация с банком</span>
        <span v-else>скрыть</span>
      </a>
    </div>

    <transition name="fade">
      <div v-show="showSync">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Начальная дата</label>
              <el-date-picker
                v-model="fromDate"
                input-id="from-date"
                input-class="form-control"
                type="date"
                placeholder="Начальная дата">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Конечная дата</label>
              <el-date-picker
                v-model="toDate"
                input-id="to-date"
                input-class="form-control"
                type="date"
                placeholder="Конечная дата">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-6 text-right">
            <div style="margin-top: 25px;">
              <a class="btn btn-primary" href="#" @click.prevent="syncBankTransactions">Cинхронизировать c Приват24</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6 text-right">
            <div style="margin-top: 25px;">
              <a class="btn btn-primary" href="#" @click.prevent="syncRegistryBankTransactions">Cинхронизировать c реестром</a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div style="margin-top: 15px;" class="text-right">
      <a class="red" href="#" @click.prevent="showRecognize = !showRecognize">
        <span v-if="!showRecognize">распознать транзакции</span>
        <span v-else>скрыть</span>
      </a>
    </div>

    <transition name="fade">
      <div v-show="showRecognize">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Начальная дата</label>
              <el-date-picker
                v-model="recFromDate"
                input-id="rec-from-date"
                input-class="form-control"
                type="date"
                placeholder="Начальная дата">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Конечная дата</label>
              <el-date-picker
                v-model="recToDate"
                input-id="rec-to-date"
                input-class="form-control"
                type="date"
                placeholder="Конечная дата">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-6 text-right">
            <div style="margin-top: 25px;">
              <a class="btn btn-primary" href="#" @click.prevent="recognizeBankTransactions">Распознать транзакции</a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <resource-list
      url="/bank-transactions"
      current-sort="text"
      resource-name="bank_transactions"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      :show-in-query="showInQuery"
      :init-page="initPage"
      :init-per-page="initPerPage"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import helpers from '@/helpers'
import resourceList from '@/components/ResourceList'
import { syncBankTransactions, syncRegistryBankTransactions, recognizeBankTransactions } from '@/services/bank_transaction.service'

export default {
  name: 'bank-transactions',
  components: { resourceList },
  data () {
    return {
      fromDate: '',
      toDate: '',

      recFromDate: '',
      recToDate: '',

      total: null,

      errors: {
        non_field_errors: []
      },

      showSync: false,
      showRecognize: false,

      fields: [
        { name: 'number', label: 'Номер', sort: true },
        { name: 'amount', label: 'Сумма', sort: true, money: true },
        { name: 'transaction_type',
          label: 'Тип операции',
          sort: true,
          decorators: {
            classes: {
              'D': 'debit',
              'C': 'credit'
            },
            values: {
              'D': 'дебет',
              'C': 'кредит'
            }
          }
        },
        { name: 'purpose', label: 'Назначение', sort: false },
        { name: 'datetime', label: 'Дата и время', sort: true, datetime: true },
        { name: 'recognized',
          label: 'Распознана',
          sort: false,
          decorators: {
            classes: {
              'true': 'debit',
              'false': 'credit'
            },
            values: {
              'true': 'да',
              'false': 'нет'
            }
          }
        }
      ],
      filters: {
        amount__gte: this.loadFromQueryParams(this.$route, 'amount__gte'),
        amount__lte: this.loadFromQueryParams(this.$route, 'amount__lte'),
        datetime__gte: this.loadFromQueryParams(this.$route, 'datetime__gte'),
        datetime__lte: this.loadFromQueryParams(this.$route, 'datetime__lte'),
        transaction_type: this.loadFromQueryParams(this.$route, 'transaction_type'),
        search: this.loadFromQueryParams(this.$route, 'search'),
        recognized: this.loadFromQueryParams(this.$route, 'recognized'),
        exclude_2pl: this.loadFromQueryParams(this.$route, 'exclude_2pl', '0')
      },
      showInQuery: [
        'search',
        'amount__gte',
        'amount__lte',
        'datetime__gte',
        'datetime__lte',
        'transaction_type',
        'page',
        'per_page',
        'recognized',
        'exclude_2pl'
      ],
      initPage: this.loadFromQueryParams(this.$route, 'page', '1'),
      initPerPage: this.loadFromQueryParams(this.$route, 'per_page', '10'),
      actionRoutes: [
        { name: 'bank-transaction-details', idName: 'bank_transaction_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    loadFromQueryParams: helpers.loadFromQueryParams,
    fillNonFieldErrors: helpers.fillNonFieldErrors,

    syncBankTransactions () {
      let fromDate
      let toDate

      if (this.fromDate) {
        fromDate = this.fromDate.toJSON()
      } else {
        fromDate = this.fromDate
      }
      if (this.toDate) {
        toDate = this.toDate.toJSON()
      } else {
        toDate = this.toDate
      }

      syncBankTransactions(fromDate, toDate).then((response) => {
        console.log(response)
        let bankTransactions = response.data

        this.showMsg('Было успешно синхронизированно ' + bankTransactions.length + ' банковских транзакций', 'success', 'Успешно')

        // hack to force child resource list component to update
        this.filters.search = '1'
        this.filters.search = ''
      }).catch(err => {
        if (err.response.status === 400) {
          this.fillNonFieldErrors(this.errors, err.response.data)
          if (this.errors.non_field_errors[0]) {
            this.showMsg(this.errors.non_field_errors[0], 'error')
          }
        }
        if (err.response.status === 404) {
          this.showMsg('Авторизуйтесь в Приват24 чтобы синхронизоваться', 'error', 'Ошибка')
          this.$router.push({ name: 'privat-auth' })
        }
      })
    },
    syncRegistryBankTransactions () {
      syncRegistryBankTransactions().then((response) => {
        let bankTransactions = response.data

        this.showMsg('Было успешно синхронизированно ' + bankTransactions.length + ' банковских транзакций из реестра', 'success', 'Успешно')

        // hack to force child resource list component to update
        this.filters.search = '1'
        this.filters.search = ''
      }).catch(err => {
        if (err.response.status === 400) {
          this.fillNonFieldErrors(this.errors, err.response.data)
          if (this.errors.non_field_errors[0]) {
            this.showMsg(this.errors.non_field_errors[0], 'error')
          }
        }
      })
    },
    recognizeBankTransactions () {
      let fromDate
      let toDate

      if (this.recFromDate) {
        fromDate = this.recFromDate.toJSON()
      } else {
        fromDate = this.recFromDate
      }
      if (this.recToDate) {
        toDate = this.recToDate.toJSON()
      } else {
        toDate = this.recToDate
      }

      recognizeBankTransactions(fromDate, toDate).then((response) => {
        let bankTransactions = response.data

        this.showMsg('Было успешно распознано ' + bankTransactions.length + ' банковских транзакций', 'success', 'Успешно')

        // hack to force child resource list component to update
        this.filters.search = '1'
        this.filters.search = ''
      }).catch(err => {
        if (err.response.status === 400) {
          this.fillNonFieldErrors(this.errors, err.response.data)
          if (this.errors.non_field_errors[0]) {
            this.showMsg(this.errors.non_field_errors[0], 'error', 'Ошибка')
          }
        }
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    },
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// BankTransactions.vue?74f1f626